import ModalPanel from '@admin/components/modal_panel'
import Searchbox from '@admin/components/searchbox'
import Infinite from '@admin/components/infinite'
import Message from '@admin/components/message'
import Articles from '../articles/results'
import PropTypes from 'prop-types'
import Results from './results'
import React from 'react'

class Categories extends React.Component {

  static propTypes = {
    onArticle: PropTypes.func,
    onCategory: PropTypes.func,
    onBack: PropTypes.func,
    onCancel: PropTypes.func
  }

  state = {
    q: ''
  }

  _handleClose = this._handleClose.bind(this)

  render() {
    const { q } = this.state
    return (
      <ModalPanel { ...this._getPanel() }>
        <div className="maha-help-main">
          <div className="maha-help-search">
            <div className="maha-help-search-query">
              <Searchbox { ...this._getSearchbox() } />
            </div>
            { q.length > 0 ?
              <Infinite { ...this._getArticles() } /> :
              <Infinite { ...this._getCategories() } />            
            }
          </div>
        </div>
      </ModalPanel>
    )
  }

  _getPanel() {
    const { onBack, onCancel } = this.props
    return {
      title: 't(Help Center)',
      leftItems: onBack ? [
        { svg: 'chevron_left', handler: onBack }
      ] : onCancel ? [
        { svg: 'x', handler: onCancel }
      ] : []
    }
  }

  _getSearch() {
    const { onArticle } = this.props
    return {
      valueKey: null,
      onArticle
    }
  }

  _getSearchbox() {
    return {
      prompt: 'Find an article...',
      onChange: this._handleType.bind(this)
    }
  }

  _getArticles() {
    const { onArticle } = this.props
    const { q } = this.state
    const empty = {
      svg: 'x',
      title: 't(No Articles)',
      text: 't(There were no articles that matched your search)'
    }
    return {
      endpoint: '/api/admin/help/articles',
      empty: <Message { ...empty } />,
      notFound: <Message { ...empty } />,
      filter: { q },
      layout: Articles,
      props: {
        onArticle
      }
    }
  }

  _getCategories() {
    const { onCategory } = this.props
    const empty = {
      svg: 'x',
      title: 't(No Categories)',
      text: 't(There are no categories)'
    }
    return {
      endpoint: '/api/admin/help/articles/categories',
      empty: <Message { ...empty } />,
      notFound: <Message { ...empty } />,
      layout: Results,
      props: {
        onCategory
      }
    }
  }

  _handleClose() {
    this.props.onClose()
  }

  _handleType(q) {
    this.setState({ q })
  }

}

export default Categories
